import { CardFieldKeyType, GenericUIConfigurationType } from '../../@types';
import {
  StripeCardElementControl,
  StripeCvcElementControl,
  StripeExpiryElementControl,
} from '../ui/controls/StripeElementControl';

export const StripeFieldMap: GenericUIConfigurationType<CardFieldKeyType> = {
  meta: {
    label: 'paymentDetails',
  },
  fields: {
    cardNumber: {
      component: StripeCardElementControl,
      name: 'cardNumber',
      label: 'cardNumber',
      id: 'cardNumber',
      className: 'LongTextControl',
    },
    expiry: {
      component: StripeExpiryElementControl,
      name: 'cardExpire',
      label: 'cardExpire',
      className: 'ShortTextControl',
    },
    cvv: {
      component: StripeCvcElementControl,
      name: 'cvv',
      label: 'cvv',
      id: 'cardCvv',
      className: 'ShortTextControl',
    },
    cardholderName: {
      name: 'cardholderName',
      label: 'cardholderName',
      className: 'LongTextControl',
    },
  },
};
